module.exports = __webpack_public_path__ + "static/media/ag.5c33e55d.svg";